<template>
  <div class="account-menu">
    <div v-if="userType === EMPLOYER"
         class="account-menu__content">
      <router-link-modified
        v-for="item in employerMenu"
        :key="item.id"
        class="account-menu__link base-btn base-btn--outline-dark base-btn--small _blue relative"
        :class="{ _disabled: item.disabled }"
        :to="item.disabled ? null : {name: item.name, params: item.params}"
      >
        {{ item.title }}
        <span v-if="item.name === 'account-received-resume' && receivedResumesCount"
              class="account-menu__link-badge">{{ receivedResumesCount }}</span>

        <BaseTooltip
          :text="$tHeader(`status-tooltip-${profileStatus.status}`)"
          tooltip-menu-style="bottom: 135%"
          class="account-menu__link-status-tooltip"
          @mouseenter.native="onMenuItemTooltipMouseEnter(item)"
          @mouseleave.native="onMenuItemTooltipMouseLeave(item)"
        >
          <template v-slot:activator>
            <div
              v-if="item.status"
              class="account-menu__link-status"
              :style="{ backgroundColor: item.status.color }"
            >
              <BaseSvg :name="item.status.icon.name" width="1.2rem" height="1.2rem" />
            </div>
          </template>
        </BaseTooltip>
      </router-link-modified>
    </div>

    <div v-else-if="userType === EMPLOYEE"
         class="account-menu__content">
      <template v-for="item in employeeMenuComputed">
        <div v-if="item.disabled || item.inDevelopment"
             :key="item.id"
             class="account-menu__link base-btn base-btn--outline-dark base-btn--small _green  _disabled">
          <div v-if="item.inDevelopment" class="account-menu__tooltip">
            {{ $tHeader('Section in development') }}
          </div>
          {{ item.title }}
        </div>
        <router-link-modified
          v-else
          :key="item.id"
          :to="{name: item.name, params: {...item.params}}"
          :class="item.inDevelopment ? '_disabled' : null"
          class="account-menu__link base-btn base-btn--outline-dark base-btn--small _green">
          {{ item.title }}
          <span v-if="item.name === 'account-recommended-vacancies' && recommendedVacanciesCount"
                class="account-menu__link-badge">{{ recommendedVacanciesCount }}</span>
          <span v-else-if="item.name === 'account-received-offers' && approvedResumesCount"
                class="account-menu__link-badge">{{ approvedResumesCount }}</span>
        </router-link-modified>
      </template>
    </div>

    <div v-else-if="userType === PARTNER"
         class="account-menu__content">
      <template v-for="item in partnerMenu">
        <router-link-modified
          v-if="item.disabled"
          :key="item.id"
          :to="{name: item.name, params: {...item.params}, meta: { ...item.meta }}"
          class="account-menu__link base-btn base-btn--outline-dark base-btn--small _blue  _disabled">
          <div v-if="item.inDevelopment" class="account-menu__tooltip">
            {{ $tHeader('Section in development') }}
          </div>
          <BaseSvg v-if="item.ico"
                   :name="item.ico.name"
                   :width="item.ico.width"
                   height="1.7rem"
                   style="margin-left: 0"/>
          <template v-if="item.title">
            {{ item.title }}
          </template>
        </router-link-modified>
        <router-link-modified
          v-else-if="!item.inDevelopment"
          :key="item.id"
          :to="{name: item.name, params: {...item.params}}"
          class="account-menu__link base-btn base-btn--outline-dark base-btn--small _blue">
          <BaseSvg v-if="item.ico"
                   :name="item.ico.name"
                   :width="item.ico.width"
                   height="1.7rem"/>
          <template v-if="item.title">
            {{ item.title }}
          </template>
        </router-link-modified>
      </template>
    </div>

    <AccountMenuModerator v-else-if="userType === MODERATOR"/>

    <AccountMenuAgent v-else-if="userType === AGENT"/>

    <!--      <button v-if="false" @click.prevent="onClickLogout"-->
    <!--              class="account-menu__link  _logout  base-btn  base-btn&#45;&#45;outline-grey  base-btn&#45;&#45;small"-->
    <!--      >-->
    <!--        <span>{{$tHeader('Logout')}}</span>-->
    <!--        <BaseSvg name="ico-logout" width="1.5rem" height="1.1rem"/>-->
    <!--      </button>-->
  </div>
</template>

<script>
  import {mapGetters, mapState} from 'vuex'
  import {EMPLOYER, EMPLOYEE, PARTNER, MODERATOR, AGENT} from '@/constants/usersTypes'
  import AccountMenuModerator from './AccountMenuModerator'
  import AccountMenuAgent from './AccountMenuAgent'

  export default {
    components: {
      AccountMenuModerator,
      AccountMenuAgent,
    },
    props: {
      userType: {
        type: Number,
        required: true
      }
    },
    data() {
      return {
        EMPLOYER,
        EMPLOYEE,
        PARTNER,
        MODERATOR,
        AGENT,
        employeeMenu: [
          {
            //   id: 1,
            //   name: "account-profile",
            //   title: this.$tProfile('Profile')
            // },{
            id: 2,
            name: 'account-my-resume',
            title: this.$tHeader('My resumes')
          }, {
            id: 7,
            name: 'account-my-vacancies',
            title: this.$tHeader('My vacancies')
          }, {
            id: 9,
            name: 'account-interaction',
            title: this.$tHeader('Interaction')
            // }, {
            //   id: 3,
            //   name: 'account-received-offers',
            //   title: this.$tReceived('Received offers')
            // }, {
            //   id: 4,
            //   name: 'account-recommended-vacancies',
            //   title: this.$tVacancies('Recommended vacancies')
          }, {
            id: 4,
            name: 'account-settings',
            title: this.$tSettings('Settings')
          }, {
            id: 5,
            name: 'account-mailing',
            title: this.$tHeader('Mailing'),
            inDevelopment: true
          }, {
            id: 6,
            name: 'help',
            title: this.$tHeader('Help')
          }
        ],
        partnerMenu: [
          {
            //   id: 1,
            //   name: "account-profile",
            //   title: this.$tProfile('Profile')
            // },{
            //   id: 1,
            //   name: 'account-resumes',
            //   title: this.$tHeader('My resumes')
            // }, {
            //   id: 7,
            //   name: 'account-my-vacancies',
            //   title: this.$tHeader('My vacancies')
            // }, {
            id: 6,
            name: 'account-dashboard',
            ico: {
              name: 'ico-dashboard',
              width: '1.4rem',
            },
            inDevelopment: true
          }, {
            //   id: 7,
            //   name: 'account-resume-list',
            //   title: this.$tHeader('Resume base'),
            //   inDevelopment: true
            // }, {
            id: 7,
            name: 'account-partner-resumes-base',
            title: this.$tHeader('Resume base'),
          }, {
            id: 8,
            name: 'account-employees',
            title: this.$tHeader('Employees'),
            inDevelopment: true
          }, {
            id: 9,
            name: 'account-partner-partners-network',
            title: this.$tHeader('Affiliate network')
          }, {
            id: 14,
            name: 'account-vacancies-responses',
            title: this.$tHeader('My responses'),
            meta: {
              url: 'hello world',
            },
          }, {
            //   id: 10,
            //   name: 'account-balance',
            //   title: this.$tHeader('Balance')
            // }, {
            id: 11,
            name: 'account-partner-statistic',
            title: this.$tHeader('Statistic'),
          }, {
            id: 12,
            name: 'account-useful-materials',
            title: this.$tHeader('Useful materials'),
          }, {
            id: 13,
            name: 'account-mailing',
            title: this.$tHeader('Mailing'),
            inDevelopment: true
          },
        ],
      }
    },
    computed: {
      ...mapState('user', [
        'resume',
        'openedInteractionId',
        'isResumeMainSectionsSaved',
        'moderatedPassport',
      ]),
      ...mapGetters('user', [
        'receivedResumesCount',
        'recommendedVacanciesCount',
        'approvedResumesCount',
        'hasInteraction',
        'bookmarksCount',
        'isEmployer',
        'employerProfile',
      ]),
      employeeMenuComputed() {
        const idsToDelete = []
        idsToDelete.push(this.hasInteraction ? 7 : 9)

        const result = this.employeeMenu.filter(item => !idsToDelete.includes(item.id))

        if (this.hasInteraction) {
          const a = result.find(item => item.id === 9)
          a.params = {id: this.openedInteractionId}
        }

        const myResume = result.find(item => item.id === 2)
        myResume.disabled = !this.resume

        const myVacancies = result.find(item => item.id === 7)
        if (myVacancies && !this.isResumeMainSectionsSaved) {
          myVacancies.disabled = !this.bookmarksCount
        } else if (myVacancies) {
          myVacancies.disabled = false
        }

        return result
      },
      employerMenu() {
        return [
          {
            id: 1,
            name: 'account-employer-profile-edit',
            title: this.$tProfile('Profile'),
            status: this.verificationStatusChip,
          }, {
            //   id: 2,
            //   name: 'account-employer-profile',
            //   title: this.$tHeader('Employer profile')
            // }, {
            id: 3,
            name: 'account-vacancies',
            title: this.$tHeader('Vacancies')
          }, {
            id: 5,
            name: 'account-vacancies-responses',
            title: this.$tHeader('My responses'),
            // }, {
            //   id: 5,
            //   name: 'help',
            //   title: this.$tHeader('Help')
          }, {
            id: 6,
            name: 'account-subscription',
            title: this.$tAccountSubscription('My subscription'),
          },
        ];
      },
      profileStatus() {
        return this.employerProfile?.profile_status || {};
      },
      verificationStatusChip() {
        if (!this.profileStatus.status) return null;

        switch (this.profileStatus.status) {
          case 'success':
            return { color: '#19c25d', icon: { name: 'ico-check' }, };
          case 'not_save':
            return { color: '#adadad', icon: { name: 'ico-cross' } };
          case 'on_moderation':
            return { color: '#f0ae2e', icon: { name: 'ico-cog' } };
          case 'rejected':
            return { color: '#EB4948', icon: { name: 'ico-cross' } };
          default:
            return { color: '#adadad', icon: { name: 'ico-cross' } };
        }
      },
    },
    methods: {
      onClickLogout() {
        if (this.pending) return
        this.pending = true

        this.$store.dispatch('user/logoutUser', { userType: this.userType })
          .finally(() => this.pending = false);
      },

      // Using for tooltip z-index (must be over toolbar)
      onMenuItemTooltipMouseEnter(item) {
        if (item.id === 1) {
          const accountPage = this.$root.$el.querySelector('.account-page');
          if (!accountPage) return console.error('Cannot find .account-page element in AccountMenu');
          accountPage.classList.add('_upper');
        }
      },
      onMenuItemTooltipMouseLeave(item) {
        if (item.id === 1) {
          const accountPage = this.$root.$el.querySelector('.account-page');
          if (!accountPage) return console.error('Cannot find .account-page element in AccountMenu');
          accountPage.classList.remove('_upper');
        }
      },
    }
  }
</script>

<style lang="less">

</style>
